import { Asterisk } from "lucide-react";

const ITEMS = [
  "Frisører & barbershops",
  "Rengøringsfirmaer",
  "Autoværksteder",
  "Restauranter & caféer",
  "Håndværkere",
  "Klinikker & behandlere",
];

export const Marquee = () => (
  <section
    aria-label="Brancher vi arbejder med"
    data-testid="industry-marquee"
    className="marquee-paused border-y border-zinc-200/80 bg-zinc-50 py-5 overflow-hidden"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center" aria-hidden={i >= ITEMS.length}>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-zinc-500 whitespace-nowrap">
            {item}
          </span>
          <Asterisk className="w-4 h-4 mx-8 text-zinc-300 shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  </section>
);
